import { Route, Routes } from "react-router-dom";
import NavbarYP from "../components/NavbarYP";
import FooterYP from "../components/FooterYP";
import Welcome from "../pages/Welcome.js";
import AboutMe from "../pages/AboutMe.js";
import "./App.css";

function App() {
  return (
    <div className="app-wrapper">
      <NavbarYP />
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/about-me" element={<AboutMe />} />
        {/* <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact-me" element={<ContactMe />} /> */}
      </Routes>
      <FooterYP />
    </div>
  );
}

export default App;
